import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { MedicoEscolasResponse } from '@/core/api/sicom-api/registro/medico/escola/escola.model';
import { EscolaPosResponse } from '@/core/api/sicom-api/registro/medico/escola/escola-pos.model';
import { CursosPosEntityResponse } from '@/core/api/sicom-api/registro/medico/escola/escola-cursos-pos-entity.model';
import { PosEspecialidadeResponse } from '@/core/api/sicom-api/registro/medico/escola/pos-especialidade.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class EscolaService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH_ESCOLAS = SICOM_PATHS.registro.medico.escolas;
    readonly PATH_ESCOLAS_POS = SICOM_PATHS.registro.medico.escolasPos;
    readonly PATH_CURSOS_POS_ENTITY = SICOM_PATHS.registro.medico.cursosPosEntity;
    readonly PATH_POS_ESPECIALIDADES = SICOM_PATHS.registro.medico.cursosPos;

    listar(uf?: string, nmSolicitante?: string, idMunicipio?: number, context?: HttpContext): Observable<MedicoEscolasResponse[]> {
        let params = new HttpParams();
        if (uf !== undefined) params = params.set('uf', uf);
        if (nmSolicitante !== undefined) params = params.set('nmSolicitante', nmSolicitante);
        if (idMunicipio !== undefined) params = params.set('idMunicipio', String(idMunicipio));
        return this.http.get<MedicoEscolasResponse[]>(this.PATH_ESCOLAS, { params, context });
    }

    // Listar escolas de pós-graduação
    listarPos(nmEscola?: string, uf: string = 'BR', context?: HttpContext): Observable<EscolaPosResponse[]> {
        let params = new HttpParams();
        if (nmEscola !== undefined) params = params.set('nmEscola', nmEscola);
        if (uf !== undefined) params = params.set('uf', uf);
        return this.http.get<EscolaPosResponse[]>(this.PATH_ESCOLAS_POS, { params, context });
    }

    // Listar cursos de pós por IES (entity)
    listarCursosPosPorIes(codIes: number, context?: HttpContext): Observable<CursosPosEntityResponse[]> {
        return this.http.get<CursosPosEntityResponse[]>(`${this.PATH_CURSOS_POS_ENTITY}/${codIes}`, { context });
    }

    // Listar especialidades de pós-graduação por curso
    listarPosEspecialidadesPorCurso(codCurso: number, context?: HttpContext): Observable<PosEspecialidadeResponse[]> {
        return this.http.get<PosEspecialidadeResponse[]>(`${this.PATH_POS_ESPECIALIDADES}/${codCurso}/especialidades`, { context });
    }
}
